module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/organize_luggage-a3834f38ad8006d282efb276a861772d.png";